document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('custom-range-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-range-styles';
    style.innerHTML = `
      .custom-range-wrapper .custom-check-label {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        cursor: pointer;
        transition: color 0.2s ease;
      }
      
      .custom-range-wrapper .custom-check-label:hover .custom-range-label { color: #000000 !important; }
      .custom-range-wrapper .custom-check-label:hover .custom-box-rect { stroke: #000000 !important; }
      .custom-range-wrapper input[type="checkbox"]:checked ~ .custom-range-label { color: #000000 !important; }

      .custom-checkbox-icons {
        position: relative;
        width: 1.6rem;
        height: 1.6rem;
        flex-shrink: 0;
      }

      .custom-range-wrapper .custom-tick {
        position: absolute;
        left: 3px;
        top: 4px;
        width: 11px;
        height: 7px;
        visibility: hidden !important;
        opacity: 0 !important;
        transition: opacity 0.2s ease;
        color: #000000; 
      }
      
      .custom-range-wrapper input[type="checkbox"]:checked ~ .custom-checkbox-icons .custom-tick {
        visibility: visible !important;
        opacity: 1 !important;
      }

      .custom-range-wrapper input[type="checkbox"]:checked ~ .custom-checkbox-icons .custom-box-rect {
        stroke: #000000 !important;
        stroke-width: 2px !important;
      }

      /* Active Class Styling */
      .custom-range-wrapper .custom-check-label.active {
        font-weight: bold; 
      }

      /* Disabled Class Styling */
      .custom-range-wrapper .custom-check-label.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none; 
      }
    `;
    document.head.appendChild(style);
  }

  const filterConfigs = [
    {
      name: 'Case Diameter',
      ranges: [
        { id: 'cd-under-20', label: 'Under 20mm', min: 0, max: 19.99 },
        { id: 'cd-20-29', label: '20–29mm', min: 20, max: 29.99 },
        { id: 'cd-30-34', label: '30–34mm', min: 30, max: 34.99 },
        { id: 'cd-35-39', label: '35–39mm', min: 35, max: 39.99 },
        { id: 'cd-40-44', label: '40–44mm', min: 40, max: 44.99 },
        { id: 'cd-45-above', label: '45mm & Above', min: 45, max: 999 }
      ]
    },
    {
      name: 'Carat',
      ranges: [
        { id: 'c-under-010', label: 'Under 0.10', min: 0, max: 0.099 },
        { id: 'c-010-050', label: '0.10 - 0.50', min: 0.10, max: 0.509 },
        { id: 'c-051-100', label: '0.51 - 1.00', min: 0.51, max: 1.009 },
        { id: 'c-101-150', label: '1.01 - 1.50', min: 1.01, max: 1.509 },
        { id: 'c-151-200', label: '1.51 - 2.00', min: 1.51, max: 2.009 },
        { id: 'c-201-250', label: '2.01 - 2.50', min: 2.01, max: 2.509 },
        { id: 'c-251-above', label: '2.51 & Above', min: 2.51, max: 999 }
      ]
    }
  ];

  function buildCustomRanges() {
    const filterGroups = document.querySelectorAll('details.facets__disclosure, .facets__wrapper details, .mobile-facets__details');
    
    filterGroups.forEach((group, index) => {
      const summary = group.querySelector('summary');
      if (!summary) return;
      const summaryText = summary.textContent.trim();
      const matchedConfig = filterConfigs.find(config => summaryText.includes(config.name));
      if (!matchedConfig) return; 
      if (group.querySelector('.custom-range-wrapper')) return;
      const originalList = group.querySelector('ul.facets__list, ul.facets-layout, .facets__display ul');
      if (!originalList) return;
      const originalInputs = originalList.querySelectorAll('input[type="checkbox"]');
      if (originalInputs.length === 0) return;
      const firstLi = originalInputs[0].closest('li');
      const firstLabel = originalInputs[0].closest('label');
      let themeLiClass = firstLi ? firstLi.className : 'list-menu__item facets__item';
      let themeLabelClass = firstLabel ? firstLabel.className : 'facets__label facet-checkbox';
      const themeInputClass = originalInputs[0].className || '';

      themeLabelClass = themeLabelClass.replace(/\bactive\b/g, '').replace(/\bdisabled\b/g, '').trim();

      originalList.style.display = 'none';

      const customUl = document.createElement('ul');
      customUl.className = originalList.className + ' custom-range-wrapper'; 
      customUl.style.marginTop = '1rem';
      const selectedBands = [];
      matchedConfig.ranges.forEach(range => {
        let hasMatches = false;
        let isAnyChecked = false;
        let matchedInputs = [];
        let totalCount = 0; 
        originalInputs.forEach(input => {
          const labelWrapper = input.closest('label') || input.nextElementSibling;
          if(!labelWrapper) return;
          const labelText = labelWrapper.innerText || labelWrapper.textContent;
          const match = labelText.match(/\d+(\.\d+)?/);
          if(!match) return;
          const numValue = parseFloat(match[0]);
          if (numValue >= range.min && numValue <= range.max) {
            hasMatches = true;
            matchedInputs.push(input);
            if (input.checked) {
              isAnyChecked = true;
            }
            const countMatch = labelText.match(/\((\d+)\)/);
            if (countMatch && countMatch[1]) {
              totalCount += parseInt(countMatch[1], 10); 
            }
          }
        });

        if (hasMatches) {
          if (isAnyChecked) {
            selectedBands.push({ label: range.label, values: matchedInputs.map(i => i.value) });
          }
          const li = document.createElement('li');
          li.className = themeLiClass;
          const uniqueId = `custom-filter-${range.id}-${index}-${Math.random().toString(36).substr(2, 9)}`;
          let dynamicLabelClass = `${themeLabelClass} custom-check-label`;
          if (isAnyChecked) {
            dynamicLabelClass += ' active';
          }
          if (totalCount === 0) {
            dynamicLabelClass += ' disabled';
          }
          
          li.innerHTML = `
            <label for="${uniqueId}" class="${dynamicLabelClass}">
              <input type="checkbox" id="${uniqueId}" ${isAnyChecked ? 'checked' : ''} ${totalCount === 0 ? 'disabled' : ''} autocomplete="off" class="${themeInputClass}">
              <div class="custom-checkbox-icons">
                <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <rect class="custom-box-rect" width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="custom-tick" viewBox="0 0 12 9">
                  <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path>
                </svg>
              </div>
              <span class="facet-checkbox__text">
                <span class="facet-checkbox__text-label" aria-hidden="true">${range.label}</span>
                <span>(${totalCount})</span>
              </span>
            </label>
          `;  

          const customCheckbox = li.querySelector('input');
          customCheckbox.addEventListener('change', (e) => {
            const isChecked = e.target.checked;
            const label = e.target.closest('label');
            if (isChecked) {
              label.classList.add('active');
            } else {
              label.classList.remove('active');
            }
            matchedInputs.forEach(origInput => { origInput.checked = isChecked; });
            const form = originalInputs[0].closest('form');
            if(form) form.dispatchEvent(new Event('input', { bubbles: true }));
          });
          customUl.appendChild(li);
        }
      });

      originalList.parentNode.insertBefore(customUl, originalList);

      /*
        The "N selected" count and the summary aria-label are rendered by Liquid from
        Shopify's individual values, so ticking one band reads as "13 selected" even
        though the customer chose a single range. Restate both in terms of bands.

        Only the number is swapped, so whatever wording the locale file supplies
        ("13 selected", "(13)") is preserved. Requested by the client on
        10 September 2026.
      */
      group.querySelectorAll('.facets__selected').forEach(el => {
        el.textContent = el.textContent.replace(/\d+/, selectedBands.length);
      });

      const groupSummary = group.querySelector('summary');
      const summaryLabel = groupSummary && groupSummary.getAttribute('aria-label');
      if (summaryLabel) {
        groupSummary.setAttribute('aria-label', summaryLabel.replace(/\(\s*\d+/, '(' + selectedBands.length));
      }

      expandBandPills(originalInputs[0].name, selectedBands);
    });
  }

  /*
    Replace the single summary pill Liquid rendered for a banded facet with one pill
    per ticked band, named after the band the customer actually clicked.

    Liquid only sees the individual values, so it can only offer a span across all of
    them. That span lies whenever two bands are ticked that are not neighbours: pick
    0.10-0.50 and 1.51-2.00 and it reads "0.19 - 2", which suggests the 0.51-1.50
    rings are in the results when they are not. The band labels are only known here,
    hence doing it client side.

    Each pill removes just its own band's values and leaves every other filter alone.
  */
  function expandBandPills(paramName, selectedBands) {
    if (!paramName || !selectedBands.length) return;

    /*
      Work a pill row at a time, because the desktop and mobile rows each hold their
      own copy. Normally there is one pill to replace, the summary Liquid rendered.
      If the facet's source changes and Liquid stops recognising it as banded there
      will be one pill per value instead, so replace however many are found rather
      than assuming a single one.
    */
    document.querySelectorAll('.active-facets').forEach(row => {
      const pills = row.querySelectorAll(
        'facet-remove[data-facet-param="' + paramName + '"]:not([data-bands-expanded])'
      );
      if (!pills.length) return;

      const template = pills[0].querySelector('a');
      if (!template) return;
      const facetLabel = pills[0].getAttribute('data-facet-label') || '';

      const markup = selectedBands.map(band => {
        const params = new URLSearchParams(location.search);
        const survivors = params.getAll(paramName).filter(value => band.values.indexOf(value) === -1);
        params.delete(paramName);
        survivors.forEach(value => params.append(paramName, value));
        const query = params.toString();

        const anchor = template.cloneNode(true);
        anchor.setAttribute('href', location.pathname + (query ? '?' + query : ''));

        const inner = anchor.querySelector('.active-facets__button-inner');
        const textNode = inner && Array.prototype.filter.call(
          inner.childNodes,
          node => node.nodeType === 3 && node.textContent.trim()
        )[0];
        if (textNode) {
          textNode.textContent = ' ' + facetLabel + ': ' + band.label + ' ';
        }

        return '<facet-remove data-facet-param="' + paramName + '" data-bands-expanded>' +
          anchor.outerHTML +
          '</facet-remove>';
      }).join('');

      pills[0].insertAdjacentHTML('beforebegin', markup);
      pills.forEach(pill => pill.remove());
    });
  }

  buildCustomRanges();

  const observer = new MutationObserver((mutationsList) => {
    let shouldUpdate = false;
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldUpdate = true;
        break;
      }
    }
    
    if (shouldUpdate) {
      buildCustomRanges();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});